/** How the apps show a date to a reader. */
export const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy';

/**
 * The year from which the legal data stores a date that is no date: an Erlass without an end of
 * validity carries a far-away placeholder instead of `null`.
 */
const LEGAL_PLACEHOLDER_YEAR = 2100;

/**
 * `yyyy-mm-dd` in the reader's own timezone. `toISOString()` answers in UTC and would put the day
 * boundary out by the offset.
 *
 * @param {Date} date - The moment to name
 * @returns {string} The calendar day it falls on
 */
export function toLocalDateKey(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * Reads a date of the legal data, where the far-away placeholder year means «no date».
 *
 * @param {string | null | undefined} value - The stored date
 * @returns {string | null} The date as it was given, or `null` for none or the placeholder
 */
export function resolveLegalDate(value: string | null | undefined): string | null {
  return value && new Date(value).getFullYear() < LEGAL_PLACEHOLDER_YEAR ? value : null;
}
